import FeeDefinitionType from "@/models/Products/ProductFees/FeeDefinitionType";

export default (val: FeeDefinitionType) => {
    let returnVal = "Undefined";
    switch (val) {
        case FeeDefinitionType.Manual:
            returnVal = "Manual"
            break;
        case FeeDefinitionType.Monthly:
            returnVal = "Monthly"
            break;
    }
    return returnVal;
}